import { TimeComparator } from "./time-comparator";

export class DayComparator extends TimeComparator {

    isOnInterval(): boolean {
        
        let days = this.timeSum / 1000 / 60 / 60 / 24;
        return days < 1;
    }
}